import scrollToSection from 'helpers/scrolling/scrollToSection';

export default function onKeyPressScrollTo (e) {
  let code = (e.keyCode ? e.keyCode : e.which);
  if (code === 35) {
    scrollToSection('#footer', true, false, 1);
    return false;
  }
  if (code === 36) {
    scrollToSection('#', true, false, 1);
    return false;
  }
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/scrolling/onKeyPressScrollTo.js